import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';
import { createPartialNameCellRenderer, createNameFieldComparator } from 'timeSheet/utils';

const useFirstNameColumn = ({ groupBy }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => params.data?.employee?.firstName?.toLowerCase() || '', []);
  const cellRenderer = useMemo(() => createPartialNameCellRenderer({ groupBy, showOnlyFirstName: true }), [groupBy]);
  const comparator = useMemo(
    () =>
      createNameFieldComparator({
        fieldName: 'firstName',
        isGroupedByEmployee: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.EMPLOYEE
      }),
    [groupBy]
  );

  return useMemo(
    () => ({
      field: 'firstName',
      headerName: t('firstName'),
      width: 250,
      initialHide: true,
      cellClass: 'justify-start',
      valueGetter,
      cellRenderer,
      comparator
    }),
    [t, valueGetter, cellRenderer, comparator]
  );
};

export default useFirstNameColumn;
